import { render, staticRenderFns } from "./historical_footprint.vue?vue&type=template&id=a589e374&scoped=true&"
import script from "./historical_footprint.vue?vue&type=script&lang=js&"
export * from "./historical_footprint.vue?vue&type=script&lang=js&"
import style0 from "./historical_footprint.vue?vue&type=style&index=0&id=a589e374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a589e374",
  null
  
)

export default component.exports